var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRubSymbolR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.4 10V.7H6.1a2.25 2.25 0 0 1 0 4.5H1.4M1.4 7.7H6.8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRubSymbolR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rub-symbol-r.46cc17fa633807b9691c9afa22d78dee.svg";